import * as React from "react";
import { FormControl, MenuItem, Select } from "@mui/material";
import { useEffect } from "react";
import { useState } from "react";
function Dropdown(props: any) {
  const {
    key_name,
    option,
    handleChange,
    ids,
    list_name,
    opt_list,
    end_point,
    defaults,
    noDefault,
  } = props;
  const [val, setval] = useState(0);
  useEffect(() => {
    if (props[key_name]) {
      setval(props[key_name]);
    } else {
      setval(0);
    }
  }, [props[key_name]]);

  return (
    <FormControl sx={{ width: "100%" }} size="small">
      <Select
        labelId="demo-select-small"
        id={key_name}
        value={val}
        style={{
          backgroundColor: "#FFFFFF",
          borderRadius: "10px",
          height: "36px",
        }}
        name={key_name}
        onChange={handleChange}
      >
        {!noDefault && (
          <MenuItem value={0}>
            {defaults ? defaults : "Choose any one..."}
          </MenuItem>
        )}
        {(option ? option : opt_list?.[end_point])?.map((a, i) => {
          return (
            <MenuItem key={i} value={a[ids]}>
              {a[list_name]}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}
export default React.memo(Dropdown);
